import React from 'react';
import { simulatorRegistry } from '../utils/simulatorRegistry';

// 종합평가(order 11) 이후는 "간이시뮬레이터" (Appendix)로 분류
const APPENDIX_ORDER_THRESHOLD = 11;

const MainPortal = ({ activeSimulator, onSimulatorChange }) => {
  const simulators = simulatorRegistry.getAllSimulators();

  return (
    <div className="w-64 bg-slate-900 shadow-lg border-r border-slate-700 flex flex-col h-full">
      {/* 헤더 */}
      <div className="p-4 border-b border-slate-700 flex-shrink-0">
        <h1 className="text-xl font-bold text-slate-100">
          반도체 공정 시뮬레이터
        </h1>
        <p className="text-sm text-slate-400 mt-1">
          v1.1 | 교육용 시뮬레이터
        </p>
      </div>

      {/* 네비게이션 메뉴 - 스크롤 가능 */}
      <nav className="mt-4 flex-1 overflow-y-auto pb-4">
        {simulators.map((simulator, idx) => {
          const isAppendix = simulator.order > APPENDIX_ORDER_THRESHOLD;
          const prev = idx > 0 ? simulators[idx - 1] : null;
          const showAppendixHeader =
            isAppendix && (!prev || prev.order <= APPENDIX_ORDER_THRESHOLD);

          return (
            <React.Fragment key={simulator.id}>
              {showAppendixHeader && (
                <div className="px-4 pt-3 pb-1 mx-2 mt-2 border-t border-slate-700/60">
                  <div className="text-[10px] font-semibold tracking-widest text-slate-500 uppercase">
                    Appendix
                  </div>
                </div>
              )}
              <div
                onClick={() => simulator.available && onSimulatorChange(simulator.id)}
                className={`px-4 py-3 mx-2 rounded-lg cursor-pointer transition-colors ${
                  activeSimulator === simulator.id && simulator.available
                    ? 'bg-blue-900/40 text-blue-300 border-l-4 border-blue-500'
                    : simulator.available
                    ? 'text-slate-300 hover:bg-slate-800'
                    : 'text-slate-600 bg-slate-800/50 opacity-50 cursor-not-allowed'
                }`}
              >
                <div className="flex items-center">
                  <span className="text-lg mr-3">{simulator.icon}</span>
                  <div className="flex-1">
                    {isAppendix ? (
                      <>
                        <div className="font-medium">간이시뮬레이터</div>
                        <div className="text-xs text-slate-400 mt-0.5">
                          {simulator.name}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="font-medium">{simulator.name}</div>
                        {!simulator.available && (
                          <div className="text-xs text-slate-500 mt-1">준비중</div>
                        )}
                        {simulator.available && (
                          <div className="text-xs text-slate-400 mt-1">
                            {simulator.description}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </nav>
    </div>
  );
};

export default MainPortal;
